import React from 'react';

import V2SettingsIframe from '@aware/common/v2-settings-iframe';

const AxiomClassic = () => (
  <V2SettingsIframe iframeSrc="/aware/?embed=1&detailsSrc=/aware/axiom" title="Axiom" />
);

export default AxiomClassic;
